import SmartTooltipDelay from "@closeio/smart-tooltip-delay";

export default new SmartTooltipDelay({
  delay: 600,
  noDelay: 0,
  resetAfterTime: 2500,
});
